export default {
    profileBaseUrlRegex: /(.*\/profil\/)/,

    composeFilterUrl(baseUrl, filters, recap = false, page = 1, type = undefined, params = [], onlyContentPack = false) {
        let filterQuery = '';

        if (filters !== undefined && filters.length > 0) {
            filterQuery = filters.reduce((filterString, filter) => {
                return filterString + '/' + filter;
            });
        }

        const baseUrlWithTrailingSlash = baseUrl + (baseUrl.endsWith('/') ? '' : '/');

        if (recap) {
            params.push('recap=' + recap);
        }
        if (page > 1) {
            params.push('page=' + page);
        }
        if (type) {
            params.push('type=' + type);
        }
        if (onlyContentPack) {
            params.push('onlyContentPack=true');
        }
        let paramsString = '';
        if (params.length > 0) {
            paramsString = '?' + params.join('&');
        }

        return `${baseUrlWithTrailingSlash}${filterQuery}${paramsString}`;
    },

    composeProfileUrl(filters, recap = false, page = 1, type = undefined, onlyContentPack = false) {
        const currentFullUrl = window.location.href;

        const profileBaseUrl = this.profileBaseUrlRegex.exec(currentFullUrl);

        if (profileBaseUrl === null) {
            return profileBaseUrl;
        }

        return this.composeFilterUrl(profileBaseUrl[0], filters, recap, page, type, [], onlyContentPack);
    },

    extractFiltersFromUrl(url, thresholdUrlPath = '') {
        const urlParts = url.split('/');
        let isThresholdUrlPathEncountered = false;

        const filters = [];

        for (let i = 0; i < urlParts.length; i++) {
            if (isThresholdUrlPathEncountered) {
                filters.push(urlParts[i]);
            } else {
                isThresholdUrlPathEncountered = urlParts[i] === thresholdUrlPath;
            }
        }

        return filters;
    }
};
